
import { toggleClassWhenSticky } from "../utils/toggle-class-when-sticky";

export default function initNavigation() {
    const $navigation = document.querySelectorAll<HTMLElement>('#main-header-navigation');
    $navigation.forEach($container => {
        new Navigation($container);
    });
}

class Navigation {
    $el: HTMLElement | null | undefined;
    $burgerButton: HTMLButtonElement | null | undefined;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$burgerButton = $el?.querySelector('.js-burger-menu');
        this.init()
    }

    init() {
        this.toggleMenu();
        this.toggleBGColor();
        this.toggleSearch('.header-menu-right--mobile');
        this.toggleSearch('.header-menu-right');
    }

    toggleMenu() {
        this.$burgerButton?.addEventListener('click', () => {
            this.$burgerButton?.classList.toggle('burger-menu--active');
            this.$el?.classList.toggle('nav-sticky');
        })
    }

    toggleBGColor() {
        if (this.$el) {
            toggleClassWhenSticky(this.$el, 'nav-sticky',)
        }
    }

    toggleSearch(media) {
        const menu = this.$el?.querySelector(media);
        const $searchOpenButtons = menu?.querySelectorAll('.js-search-button a');
        const $searchCloseButtons = menu?.querySelectorAll('.js-search-close');
        const $searchBox = menu?.querySelector('.search-box');
        const $input = $searchBox.querySelector('input');

        $searchOpenButtons?.forEach(button => {
            button.addEventListener('click', () => {
                if ($searchBox) {
                    $searchBox.classList.add('searchbox--active');
                    $input.focus()
                    this.$burgerButton?.classList.remove('burger-menu--active');
                }
            })
        })

        $searchCloseButtons?.forEach(button => {
            button.addEventListener('click', () => {
                if ($searchBox) {
                    $searchBox.classList.remove('searchbox--active')
                }
            })
        })

    }
}

